// @ts-nocheck
import addPanelDataConsts from '@/addPanelDataConsts';

export default {
  type: addPanelDataConsts.SECTIONS_TYPES.PERSONALIZED,
  hide: false,
  title: 'add_section_label_my_menu',
  subNavigationTitle: 'add_section_label_my_menu',
  presetTitle: 'add_section_label_my_menu',
  tooltipTitle: 'add_section_label_my_menu',
  subNavigationHide: false,
  showSectionHeader: true,
  additionalBehaviours: {
    labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
    infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
    iconEnabledForComps: [],
  },
  props: {
    compTypes: [
      'wysiwyg.viewer.components.menus.DropDownMenu',
      'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu',
    ],
    verticalMargin: 30,
    horizontalMargin: 20,
    maxFontSize: 15,
    scaleProportion: {
      x: 1,
      y: 1,
    },
  },
  help: {
    hide: false,
    text: 'add_section_info_text_my_general',
  },
};
